import { Node, mergeAttributes } from '@tiptap/core';

export const DefinitionTerm = Node.create({
  name: 'definitionTerm',
  group: 'definitionTerm',
  content: 'inline*',
  defining: true, // optional but helps treat it as semantic anchor
  parseHTML() {
    return [{ tag: 'dt' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['dt', mergeAttributes(HTMLAttributes), 0];
  },
});
